import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { hkToday as libHkToday, shiftDate as libShiftDate } from "../lib/dates";
import { api } from "../api/client";
import { keys } from "../api/query-registry";

export interface DailyLogShift {
  homeId: string;
  homeName: string;
  startTime: string;
  endTime: string;
  marker: string | null;
}

export interface DailyLog {
  date: string;
  notes: string;
  completedTodos: { id: string; title: string; homeId: string | null; completedAt: string }[];
  shifts: DailyLogShift[];
}

export function useDailyLog(date: string) {
  const qc = useQueryClient();
  const query = useQuery({
    queryKey: keys.dailyLog(date),
    queryFn: () => api<DailyLog>(`/api/daily-logs/${date}`),
    staleTime: 30_000,
  });
  const save = useMutation({
    mutationFn: (notes: string) => api<DailyLog>(`/api/daily-logs/${date}`, { method: "PUT", body: { notes } }),
    onSuccess: (log) =>
      qc.setQueryData<DailyLog>(keys.dailyLog(date), (old) => ({
        date: log.date,
        notes: log.notes,
        completedTodos: old?.completedTodos ?? [],
        shifts: old?.shifts ?? [],
      })),
  });
  return { query, save };
}

export function hkToday(): string {
  return libHkToday();
}

export function shiftDate(date: string, days: number): string {
  return libShiftDate(date, days);
}
